'use client'

import { useNavBar } from '@components/nav/nav-provider'
import React from 'react'

type ErrorTemplateProps = {
  children: React.ReactNode
}
export const ErrorTemplate = ({ children }: ErrorTemplateProps): React.ReactElement => {
  useNavBar({
    fixed: true
  })

  return (
    <div className="mt-nav-bar-height md:p-xl p-md flex h-[700px] w-full flex-col items-center justify-center md:h-[90vh]">
      {children}
    </div>
  )
}
